import React from 'react';
import { Button } from '../ui/Button';

interface DraftWarningModalProps {
  isOpen: boolean;
  onSaveDraft: () => void;
  onDiscard: () => void;
  onCancel: () => void;
  saving?: boolean;
}

/**
 * Modal shown when the user tries to leave the New Run form with unsaved changes.
 * Offers three choices: Save as draft, Discard changes, or Cancel (stay).
 */
export const DraftWarningModal: React.FC<DraftWarningModalProps> = ({
  isOpen,
  onSaveDraft,
  onDiscard,
  onCancel,
  saving = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onCancel}
        aria-hidden="true"
      />

      {/* Dialog */}
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="draft-modal-title"
        className="relative z-10 w-full max-w-sm mx-4 bg-bg-primary border border-border-subtle rounded-lg shadow-xl p-6"
      >
        <h2
          id="draft-modal-title"
          className="text-base font-semibold text-text-primary mb-2"
        >
          Unsaved changes
        </h2>
        <p className="text-sm text-text-secondary mb-6">
          You have unsaved changes in this run. Save as draft before leaving?
        </p>

        <div className="flex flex-col gap-2">
          <Button
            variant="primary"
            size="sm"
            onClick={onSaveDraft}
            disabled={saving}
            isLoading={saving}
            className="w-full justify-center"
          >
            Save Draft
          </Button>
          <Button
            variant="secondary"
            size="sm"
            onClick={onDiscard}
            disabled={saving}
            className="w-full justify-center"
          >
            Discard
          </Button>
          <Button
            variant="secondary"
            size="sm"
            onClick={onCancel}
            disabled={saving}
            className="w-full justify-center"
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};
